<template>
  <div>
    <h1>新闻中心</h1>
    <div class="top" v-show="Flag">
      <div class="news">
        <span>公司新闻</span>
      </div>
      <div class="news" style="background: #accdeb" @click="changeFlag">
        <span>行业资讯</span>
      </div>
    </div>
    <div class="top" v-show="!Flag">
      <div class="news" style="background: #accdeb" @click="changeFlag">
        <span>公司新闻</span>
      </div>
      <div class="news">
        <span>行业资讯</span>
      </div>
    </div>
    <div v-if="Flag">
      <div style="margin-top: 2rem">
        <div v-for="(item, i) in NewsList">
          <div class="newsCard" @click="toLinkNews(item.id)">
            <el-image
              style="width: 12.25rem; height: 11.25rem; float: left"
              :src="item.cover"
              fit="fill"
            ></el-image>
            <div class="newsIn">
              <div class="newsTitle">{{ item.created_time }}</div>
              <div class="newsContext">{{ item.title }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!Flag">
      <div style="margin-top: 2rem">
        <div v-for="(item, i) in IndList">
          <div class="newsCard" @click="toLinkInd(item.id)">
            <el-image
              style="width: 12.25rem; height: 11.25rem; float: left"
              :src="item.cover"
              fit="fill"
            ></el-image>
            <div class="newsIn">
              <div class="newsTitle">{{ item.created_time }}</div>
              <div class="newsContext">{{ item.title }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/utils/api'
export default {
  name: 'news',
  props: {
    NewsList: {
      type: Array,
      default: null
    },
    IndList: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      Flag: true,
    }
  },
  methods: {
    changeFlag () {
      this.Flag = !this.Flag
    },
    toLinkNews (index) {
      this.$router.push({
        path: '/news/detail',
        query: {
          type: '1',
          id: index,
        },
      })
    },
    toLinkInd (index) {
      this.$router.push({
        path: '/news/detail',
        query: {
          type: '2',
          id: index,
        },
      })
    }
  },
}
</script>

<style scoped>
h1 {
  margin-top: 3rem;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 2.125rem;
  line-height: 3rem;
  align-items: center;
  text-align: center;
  text-transform: capitalize;
  color: #333333;
}
.news {
  /* width: 6.5rem; */
  height: 2.125rem;
  padding: 0.5rem;
  background: #0099da;
  border-radius: 0.5rem;
  margin: 0.5rem 1.5rem 0rem;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 1.375rem;
  line-height: 2.125rem;
  display: flex;
  /* align-items: center; */
  text-align: center;
  /* text-transform: capitalize; */
  justify-content: center;
  color: #ffffff;
}
.top {
  padding-top: 1.875rem;
  padding-bottom: 1.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.newsCard {
  width: 43.875rem;
  height: 11.25rem;
  margin: 1rem 1.5rem;
  
}
.newsIn {
  float: left;
  width: 31.625rem;
  height: 11.25rem;
  background-color: #f5f5f5;
}
.newsTitle {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 1.5rem;
  line-height: 2rem;
  display: flex;
  align-items: center;
  color: #333333;
  padding-left: 1rem;
  padding-top:1rem;
}
.newsContext {
  font-family: PingFang SC;
  font-style: normal;
  /* font-weight: 500; */
  font-size: 1.75rem;
  line-height: 2.5375rem;
  color: #333333;
  padding-left: 1rem;
  padding-top:1rem;
  padding-right: 1.5rem;
}
</style>
